module.exports = __webpack_public_path__ + "static/media/Grownu logo on white.a7acff03.png";